import $ from 'blingblingjs';
import Tablesort from 'tablesort';

const toogles = $('select[data-autosubmit]');

const getQueryString = (form) => {
    const inputs = $('select', form);
    const queries = inputs.reduce((acc, input) => `${acc}&${input.name}=${input.value}`, '');

    return queries;
};

const updateTableSorting = (wrapper) => {
    // get tables inside wrapper
    const tables = $('table', wrapper);
    // activate sorting
    tables.forEach((table) => new Tablesort(table));
};

const updateRelatedSelect = ({ id, data }) => {
    // get related select
    const [select] = $(id);
    // update content
    select.innerHTML = data;
};

const updatePageContent = (data) => {
    // loop over data
    Object.keys(data).map((key) => {
        // select page part
        const [part] = $(`#${key}`);
        // is part on page?
        if (!part) return;
        // update content
        part.innerHTML = data[key];
    });
};

const handleChange = (e) => {
    // get form url
    const url = e.target.form.action;
    // get query string
    const queries = getQueryString(e.target.form);
    // get target
    const [target] = $(e.target.dataset.target);
    // fetch data
    fetch(`${url}${queries}`)
        .then((data) => data.json())
        // update DOM
        .then((data) => {
            // update content
            target.innerHTML = data.update.content;
            // update tables
            updateTableSorting(target);
            // update page content
            updatePageContent(data.updatePageContent);
            // should we update next select?
            const selectId = e.target.dataset.replace;
            if (selectId) {
                updateRelatedSelect({ id: selectId, data: data.updateSelect.content });
            }
        });
};

toogles.on('change', handleChange);
